import {Divider, Slot, Text, Trail, Typography, UnstableCard as Paper} from '@logistics-frontend/blocks'
import {Image} from '@logistics-frontend/blocks/image'
import {spacing} from '@logistics-frontend/blocks/theme/theme'
import {useI18n} from '@logistics-frontend/core/i18n'
import {tag2url} from '@logistics-frontend/utils'
import React, {memo, useMemo} from 'react'
import {useController, useFormContext, useWatch} from 'react-hook-form'

import {useConfigContext} from '../../../../../../utils/contexts/ConfigContext'
import {InputControlled} from '../Controlled/Input'
import {PhoneInputControlled} from '../Controlled/PhoneInput'
import {SwitchControlled} from '../Controlled/Switch'
import * as classes from './Details.classes'

type OrderDetailsProps = {
  name: string
  routePointIndex: number
}

export const ContactDetails = memo(({name, routePointIndex}: OrderDetailsProps): React.ReactElement => {
  const i18n = useI18n()
  const contact = useWatch({name: `${name}.phone`})
  const {getPhoneMask} = useConfigContext()
  const {control} = useFormContext()
  const {
    fieldState: {error, invalid},
  } = useController({name: `${name}.phone`, control})

  const isSource = routePointIndex === 0

  const labelPhone = useMemo(() => {
    if (isSource) {
      if (!contact) {
        return i18n('bdui.address.input.sender_phone_choose', 'Телефон отправителя *')
      }

      return i18n('bdui.address.input.sender_phone', 'Телефон отправителя')
    }

    if (!contact) {
      return i18n('bdui.address.input.recipient_phone_choose', 'Телефон получателя *')
    }

    return i18n('bdui.address.input.recipient_phone', 'Телефон получателя')
  }, [isSource, contact, i18n])

  const labelName = useMemo(() => {
    if (isSource) {
      return i18n('bdui.address.input.sender_name', 'Имя отправителя')
    }

    return i18n('bdui.address.input.recipient_name', 'Имя получателя')
  }, [i18n, isSource])

  return (
    <Paper className={classes.detailsWrapper} padding="S">
      <InputControlled defaultValue={routePointIndex} name={`${name}.route_index`} type="hidden" />
      <PhoneInputControlled
        className={classes.suggest}
        getPhoneMask={getPhoneMask}
        label={labelPhone}
        lead={<Image height={parseInt(spacing(3))} src={tag2url('image_user_round_fill')} />}
        name={`${name}.phone`}
        size="l"
        variant="line"
      />
      <div className={classes.inputsWrapper}>
        <Divider isInvalid={invalid} />
        {invalid && (
          <Typography className={classes.errorMessage} color="error" variant="caption2">
            {error?.message}
          </Typography>
        )}
        <InputControlled label={labelName} name={`${name}.name`} size="l" variant="line" />
        <Slot Component="label">
          <Text style={{padding: 0}}>
            <Typography variant="body2">
              {i18n('bdui.address.switch.notifications_title', 'СМС подтверждение')}
            </Typography>
            <Typography color="minor" variant="caption1">
              {i18n('bdui.address.switch.notifications_subtitle', 'передачи посылки курьеру')}
            </Typography>
          </Text>
          <Trail>
            <SwitchControlled name={`${name}.notifications`} />
          </Trail>
        </Slot>
      </div>
    </Paper>
  )
})
